import axios, { encodeData } from "../utils/axios";

export const fetchPortNames = async () => {
  // Code if endpoint /portnames work

  const res = await axios.get("/portnames").catch((error) => {
    if (error.response) {
      console.error(error);
    }
  });

  return res.data;
};

export const createPortName = async (newPortName) => {
  await axios.post("/portnames/create", encodeData(newPortName));
};

export const updatePortName = async (updatePortName) => {
  await axios.put("/portnames/update", encodeData(updatePortName));
};

export const deletePortName = async (oldPortName) => {
  await axios.delete("/portnames/delete", {
    data: encodeData(oldPortName),
  });
};
